module.exports = __webpack_public_path__ + "static/media/GothamLight.67aadb76.woff2";